export default "__VITE_ASSET__DaUCQzqJ__"